<template>
  <AddCourse />
</template>
<script>
import appConfig from '@/app.config'
import AddCourse from '../../../components/mooc/courses/AddCourse.vue'
export default {
  page: {
    title: 'ثبت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-add-courses',
  components: {
    AddCourse,
  },
}
</script>
